import { Card, Row, FormInstance, Form } from 'antd';
import React from 'react';
import UtinaCard from 'components/UtinaCard';
import Bank from 'components/Bank';
import { isNil } from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type TabBkInfoSFSProps = {
  form: FormInstance;
  id: number;
  data?: any;
};

const TabBkInfoSFS = ({ form, id, data }: TabBkInfoSFSProps) => {
  return (
    <>
      <Card
        title={
          <GetLabel
            label="bank-information"
            style={{ fontWeight: 'bold', paddingLeft: 15 }}
          />
        }
        style={{
          width: '100%',
          boxShadow:
            'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
          marginBottom: 10,
        }}
        bordered
      >
        <Row gutter={16}>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <UtinaCard comcode="BankDetails" level={5} xs={12}>
                <Bank
                  countcode={getFieldValue('countcode')}
                  currcode={getFieldValue('currcode')}
                  bankField="bkcodemain"
                  branchField="bkbranchcodemain"
                  cbkeyField="bkaccountkeymain"
                  cbnumField="bkaccountnummain"
                  ibanField="tpibanmain"
                  bicField="tpbicmain"
                  banknameField="tpbanknamemain"
                  form={form}
                  disabled={!isNil(data?.bankAccount?.tpiban)}
                  colU={12}
                />
              </UtinaCard>
            )}
          </Form.Item>
        </Row>
      </Card>
      {/* <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined
            style={{ fontSize: 24, float: 'left' }}
            rotate={isActive ? 90 : 0}
          />
        )}
        expandIconPosition="left"
        defaultActiveKey={['1']}
      >
        <Panel
          disabled={!id}
          header={<Title level={5} comcode="all-bank-accounts"></Title>}
          key="2"
          style={{
            marginBottom: 24,
            overflow: 'hidden',
            background: '#f7f7f7',
            border: 10,
            borderRadius: 2,
            boxShadow:
              'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
          }}
        >
          <Card bordered>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <BankAccountsList
                  form={form}
                  tpid={id}
                  showAsModal={showAsModal}
                  countcode={getFieldValue('countcode')}
                  currcode={getFieldValue('currcode')}
                />
              )}
            </Form.Item>
          </Card>
        </Panel>
      </Collapse> */}
    </>
  );
};

export default TabBkInfoSFS;
